import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import IndexPage from './pages/index.vue';
import ContactUs from './pages/contact_us.vue';
import AboutPart from './pages/aboutpart.vue';
import RealizedProducts from './pages/realized_products.vue';
import RealizedProductsDetail from './pages/realized_product_detail.vue';
import PrivetSchools from './pages/privet_schools.vue';
import PrivetSchoolsDetail from './pages/privet_schools_detail.vue';
import ObjectsGCHP from './pages/objects_gchp.vue';
import ObjectsGCHPdetail from './pages/object_gchp_detail.vue';
import NewsDetail from './pages/news_detail.vue';

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior: function(to) {
        if (to.hash) {
            return {selector: to.hash}
        } else {
            return {x: 0, y: 0}
        }
    },
    routes: [
        { path: '/', component: IndexPage },
        {
            path: '/',
            component: () => import('./layout/main.vue'),
            children: [
                { path: '/contact-us', component: ContactUs },
                { path: '/about-part', component: AboutPart },
                { path: '/realized-objects', component: RealizedProducts },
                { path: '/realized-objects/:id', component: RealizedProductsDetail },
                { path: '/private-schools', component: PrivetSchools },
                { path: '/city/:id', component: ObjectsGCHP },
                { path: '/object/:id', component: ObjectsGCHPdetail },
                { path: '/privet-school/:id', component: PrivetSchoolsDetail },
                { path: '/news/:id', component: NewsDetail },
            ]
        }
  /*      {
            path: '/',
            component: () => import('./layout/innerpage.vue'),
            children: [
                { path: '/:lang/city/:id', component: ObjectsGCHP },
                { path: '/:lang/object/:id', component: ObjectsGCHPdetail },
                { path: '/:lang/privet-school/:id', component: PrivetSchoolsDetail },
            ]
        }*/
    ]
});

router.afterEach(() => {
    // Remove initial loading
    const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
})

export default router
